import React from 'react';
import PropTypes from 'prop-types';
import {DatePickerWrapper} from 'components/DatePickerWrapper.js';
import {DateUtil} from 'utils/date-util.js';

const EartagDroppedSensorSummarizer = (props) => {
  const endDate = props.endDate;
  const setEndDate = props.setEndDate;
  const informationStyle = {
    marginLeft: 80,
    marginBottom: 20,
    padding: 4,
    fontSize: 14,
    borderRadius: 10,
    width: 500,
    backgroundColor: '#EEEEEE'
  };
  const dateStyle = {
    marginLeft: 40,
    marginBottom: 20
  };

  return (
    <div>
      <div className={props.classes.flexContainer} style={informationStyle}>
        <ul>
          <li>月初 〜 指定した終了日までのイヤタグ脱落アラートを集計します。</li>
          <li>終了日を指定しない場合は実行日の前日までの集計となります。</li>
          <li>ファイル送信先チャンネル: notify-test</li>
        </ul>
      </div>
      <ul className={props.classes.flexContainer} style={dateStyle}>
        <li>
          <DatePickerWrapper
            label={'終了日'}
            date={endDate}
            margin="none"
            syncState={(e) => setEndDate(DateUtil.startOfDay(e))}
          />
        </li>
      </ul>
    </div>
  );
};

EartagDroppedSensorSummarizer.propTypes = {
  endDate: PropTypes.instanceOf(Date),
  setEndDate: PropTypes.func,
  classes: PropTypes.shape({
    flexContainer: PropTypes.string
  })
};

export default EartagDroppedSensorSummarizer;
